import React from "react";

import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import makeStyles from "@mui/styles/makeStyles";

import Persona from "persona";

import personaStyles from "../styles/personaStyles.js";

const usePersonaStyles = makeStyles(personaStyles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PersonaVerificationDialog = (props) => {
  let {
    fullScreen,
    // classes,
    email,
    phoneNumber,
    visitID,
    userID,
    openInquiryID,
    onComplete,
    onReady,
    onLoad,
  } = props;

  const classes = usePersonaStyles();

  // console.log("persona dialog props: ", props);
  // console.log("userID: ", userID);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={true}
      TransitionComponent={Transition}
    >
      <div
        id="personaDiv"
        style={{}}
        className={classes.personaVerificationDiv}
      >
        <Persona.Inquiry
          referenceId={userID} // this maps to a Kick user ID
          fields={{
            // "name-first": "Justin",
            // "name-last": "Ip",
            // birthdate: "1980-03-01",
            // "visit-id": "75c1d2eb-3d58-473f-9c64-ea045adfd716",
            // "email-address": "justin@gokick.com",
            // "phone-number": "555-1234",
            "visit-id": visitID,
            "email-address": email,
            "phone-number": phoneNumber,
          }}
          templateId={openInquiryID ? "" : "itmpl_q7qB2rQNwtmo13CzwUX25sqS"} // Original Persona Flow
          // templateId="itmpl_diBfL5D9D9nSbFX1SWQZDup3" // New Custom Persona Flow with forced Facebook browser ejection and under 18 age verification
          environmentId="env_TkMdXBcADZdsZbEP6TQPPbam"
          inquiryId={openInquiryID} // Specify an inquiry ID to resume an existing inquiry. The sessionToken parameter is required if the inquiry's status is pending. Do not pass a templateId or templateVersionId when resuming the inquiry
          //   sessionToken="" //When resuming an inquiry with a pending status, you must also generate a session token from the /api/v1/inquiries/<inquiry-id>/resume endpoint.
          onReady={() => {
            onReady && onReady();
          }}
          onLoad={() => {
            onLoad && onLoad();
          }}
          //   onCancel={(inquiryId, sessionToken) = {}}
          onComplete={({ inquiryId, status, fields }) => {
            // Inquiry completed. Optionally tell your server about it.
            console.log(`Sending finished inquiry ${inquiryId} to backend`);
            onComplete(inquiryId, status, fields);
          }}
        />
      </div>
    </Dialog>
  );
};

export default PersonaVerificationDialog;
